import { aboutTranslations } from '../translations/about';
import { bookingTranslations } from '../translations/booking';
import { contactTranslations } from '../translations/contact';
import { homeTranslations } from '../translations/home';
import { kranevoTranslations } from '../translations/kranevo';
import { locationsTranslations } from '../translations/locations';
import { packagesTranslations } from '../translations/packages';
import { plovdivTranslations } from '../translations/plovdiv';
import { sofiaBoyanaTranslations } from '../translations/sofiaBoyana';
import { sofiaMladostTranslations } from '../translations/sofiaMladost';
import { sofiaNsaTranslations } from '../translations/sofiaNsa';

export const pageContentConfig = [
  { key: 'home', label: 'Home', route: '/', translations: homeTranslations },
  { key: 'about', label: 'About', route: '/about', translations: aboutTranslations },
  { key: 'packages', label: 'Packages', route: '/packages', translations: packagesTranslations },
  { key: 'locations', label: 'Locations', route: '/locations', translations: locationsTranslations },
  { key: 'contact', label: 'Contact', route: '/contact', translations: contactTranslations },
  { key: 'booking', label: 'Booking', route: '/book', translations: bookingTranslations },
  {
    key: 'sofia-mladost',
    label: 'Sofia Mladost',
    route: '/locations/sofia-mladost',
    translations: sofiaMladostTranslations
  },
  {
    key: 'sofia-nsa',
    label: 'Sofia NSA',
    route: '/locations/sofia-nsa',
    translations: sofiaNsaTranslations
  },
  { key: 'plovdiv', label: 'Plovdiv', route: '/locations/plovdiv', translations: plovdivTranslations },
  {
    key: 'sofia-boyana',
    label: 'Sofia Boyana',
    route: '/locations/sofia-boyana',
    translations: sofiaBoyanaTranslations
  },
  { key: 'kranevo', label: 'Kranevo', route: '/locations/kranevo', translations: kranevoTranslations }
];
